import React, { forwardRef } from 'react';

import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { validate } from '@vlabs/shared';
import { useFormContext } from 'react-hook-form';

import { useSearchApi } from '../../../../api/SearchApiProvider';
import { useApiData } from '../../../../api/useApiData';
import st from '../popovers.module.sass';

function HandlersFilterPopover(
  {
    name = 'handler_ids',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { control } = useFormContext();
  const api = useSearchApi();
  const { data: handlerOptions = [] } = useApiData(api.getHandlerOptions);

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <ControllableOptionsFilter
        control={control}
        isCreatable
        name={name}
        options={handlerOptions}
        validateProp={validate.UUIDValidator()}
        visibleCount={5}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const HandlersFilterPopoverWithRef = forwardRef(HandlersFilterPopover);
export { HandlersFilterPopoverWithRef as HandlersFilterPopover };
